module.exports = __webpack_public_path__ + "static/media/HR-04.dcfd601e.svg";